<template>
  <div
    class="side_nav_wrapper"
    :class="{ active: navIsActive, closed: !isOpened }"
  >
    <!-- Start:: Toggle Btn -->

    <button class="close-side" @click="onOpen">
      <i class="fas fa-angle-right"></i>
    </button>
    <button><i class="fa-solid fa-right-to-bracket"></i></button>
    <!-- End:: Logo -->

    <!-- Start:: Side Nav Links -->
    <div class="side_nav_links_wrapper">
      <button class="close_btn" @click="$emit('fireToggleNavDrawerEmit')">
        <i class="fal fa-times"></i>
      </button>
      <!-- End:: Toggle Btn -->

      <!-- Start:: Logo -->
      <div class="logo_wrapper" v-if="getAppTheme == 'light_theme'">
        <router-link class="logo" to="/home">
          <img
            src="@/assets/media/logo/logo.png"
            alt="سكن وسفر"
            width="170"
            height="56"
          />
        </router-link>
      </div>

      <div class="logo_wrapper" v-else>
        <router-link class="logo logo-sidebar" to="/home">
          <img
            src="@/assets/media/logo/logo-white.png"
            alt="سكن وسفر"
            width="170"
            height="56"
          />
        </router-link>
      </div>
      <!-- Start:: Home Route -->
      <div class="home_route" @click="$emit('fireToggleNavDrawerEmit')">
        <router-link to="/home">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/home.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.dashboard") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Home Route -->

      <!-- Start::  Roles and Admins Routes-->
      <!-- <div class="side_routes_wrapper">
        <a-menu
          style="width: 100%"
          mode="vertical"
          :open-keys="openKeys"
          @openChange="onOpenChange"
          v-if="
            $can('roles index', 'roles') ||
            $can('permissions-index', 'permissions') ||
            $can('admins-index', 'admins') ||
            $can('admins index', 'admins') ||
            $can('users index', 'users')
          "
        >
          <a-sub-menu
            v-for="item in sideNavbarList_Admins"
            :key="item.key"
            :data-type="!item.children ? 'single_route' : ''"
          >
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item
                v-for="childItem in item.children"
                :key="childItem.key"
                v-if="childItem.hasPermission"
              >
                <button
                  v-if="childItem.hasPermission"
                  class="text-start w-100"
                  @click="$emit('fireToggleNavDrawerEmit')"
                >
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div> -->

      <v-list dense>
        <template
          v-if="
            $can('roles index', 'roles') ||
            $can('permissions-index', 'permissions') ||
            $can('admins index', 'admins')
          "
        >
          <v-list-group
            v-for="item in sideNavbarList_Admins"
            :key="item.key"
            no-action
            append-icon=""
          >
            <template v-slot:activator>
              <div
                class="dropdown-activator d-flex align-center justify-space-between"
              >
                <div class="d-flex align-center">
                  <img :src="item.icon" alt="icon" width="35" height="35" />
                  <span class="ml-2">{{ item.title }}</span>
                </div>
                <i class="fas fa-angle-down"></i>
              </div>
            </template>

            <v-list-item
              v-for="childItem in item.children"
              :key="childItem.key"
              v-if="childItem.hasPermission"
              @click="$emit('fireToggleNavDrawerEmit')"
            >
              <router-link
                :to="childItem.route"
                class="home_route d-flex align-center"
              >
                <v-icon small class="mr-2">mdi-circle</v-icon>
                <span>{{ childItem.title }}</span>
              </router-link>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <!-- <div class="side_routes_wrapper side_routes_wrapper_clients">
        <a-menu
          style="width: 100%"
          mode="vertical"
          :open-keys="openKeys"
          @openChange="onOpenChange"
          v-if="$can('clients index', 'clients')"
        >
          <a-sub-menu
            v-for="item in sideNavbarList_users"
            :key="item.key"
            :data-type="!item.children ? 'single_route' : ''"
          >
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item
                v-for="childItem in item.children"
                :key="childItem.key"
              >
                <button
                  v-if="childItem.hasPermission"
                  class="text-start w-100"
                  @click="$emit('fireToggleNavDrawerEmit')"
                >
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div> -->
      <!-- End::  Roles and Admins Routes -->

      <!-- Start:: Admins Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('admins index', 'admins')"
      >
        <router-link to="/admins/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/admins.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.adminsManeg") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: Admins Route -->
      <!-- Start:: Capacities Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('capacities index', 'capacities')"
      >
        <router-link to="/Capacities/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/orders.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.Capacities") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: Admins Route -->

      <!-- Start:: users Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('users index', 'users')"
      >
        <router-link to="/users/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/users.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.manage_users") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: users Route -->

      <!-- Start:: users Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('clients index', 'clients')"
      >
        <router-link to="/Clients/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/users.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Clients.title") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: users Route -->

      <!-- Start:: Customers Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('customers index', 'customers')"
      >
        <router-link to="/Customers/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/users_red.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Customers.title") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: Customers Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('users index', 'users')"
      >
        <router-link to="/Clients/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/users.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Clients.title") }}
          </span>
        </router-link>
      </div>
      <!-- Start:: Students Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('clients index', 'clients')"
      >
        <router-link to="/students/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/users.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.students") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Students Route -->

      <!-- Start:: academic stages Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('academic stages index', 'academic-stages')"
      >
        <router-link to="/academic-stages/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(59, 179, 227, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/stages.png"
              alt="icon"
              width="35"
              height="35"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.academic_stages") }}
          </span>
        </router-link>
      </div>
      <!-- End:: academic stages Route -->

      <!-- Start:: academic years Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('academic years index', 'academic-years')"
      >
        <router-link to="/academic-years/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(242, 136, 48, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/academic_years.png"
              alt="icon"
              width="25"
              height="25"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.academic_years") }}
          </span>
        </router-link>
      </div>
      <!-- End:: academic years Route -->

      <!-- Start:: Specializations Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('specialization index', 'specialization')"
      >
        <router-link to="/specializations/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(127, 173, 57, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/badge.png"
              alt="icon"
              width="25"
              height="25"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.specializations") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Specializations Route -->

      <!-- Start:: Subjects Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('study subject index', 'study-subject')"
      >
        <router-link to="/subjects/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(114, 163, 153, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/books.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.subjects") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Subjects Route -->

      <!-- Start:: Categories Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('course category index', 'course-category')"
      >
        <router-link to="/categories/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/folder.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.categories") }}
          </span>
        </router-link>
      </div>
      <!-- End:: Categories Route -->

      <!-- Start:: additional_fields Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('additional fields index', 'additional-fields')"
      >
        <router-link to="/additional-fields/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(109, 194, 249, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/plus.svg"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.additional_fields") }}
          </span>
        </router-link>
      </div>
      <!-- End:: main_sadditional_fieldsections Route -->

      <!-- Start:: sub_sections Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('subcategories index', 'subcategories')"
      >
        <router-link to="/sub-categories/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/folder.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.sub_sections") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: sub_sections Route -->

      <!-- Start:: acceptedproviders Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('withdraw_requests index', 'withdraw_requests')"
      >
        <router-link to="/request-wallets/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/bill.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.service_provider_wallet_requests") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: service_provider_wallet_requests Route -->

      <!-- Start:: orders Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('orders index', 'orders')"
      >
        <router-link to="/orders/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/paymentmethods.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.orders") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: orders Route -->
      <!-- Start:: orders Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('coupons index', 'coupons')"
      >
        <router-link to="/financialorders/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/budgeting.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.FinancialOrders") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: orders Route -->
      <!-- Start:: orders Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('coupons index', 'coupons')"
      >
        <router-link to="/financialpack/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/budgeting.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.financialpack") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: orders Route -->
      <!-- Start:: orders Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('coupons index', 'coupons')"
      >
        <router-link to="/coupons/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/coupon.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.coupons") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: orders Route -->

      <!-- Start:: reasons Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('reasonscancellations index', 'reasonscancellations')"
      >
        <router-link to="/reasons/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/cancel.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.reasons") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: reasons Route -->

      <!-- Start:: sideNavbarList_providers Route -->
      <!-- <div class="side_routes_wrapper">
        <a-menu
          style="width: 100%"
          mode="vertical"
          :open-keys="openKeys"
          @openChange="onOpenChange"
          v-if="$can('teachers index', 'teachers')"
        >
          <a-sub-menu
            v-for="item in sideNavbarList_providers"
            :key="item.key"
            :data-type="!item.children ? 'single_route' : ''"
            style="border: none"
          >
            <template v-if="item.children">
              <span slot="title">
                <img :src="item.icon" alt="icon" width="35" height="35" />
                <span> {{ item.title }} </span>
              </span>

              <a-menu-item
                v-for="childItem in item.children"
                :key="childItem.key"
              >
                <button
                  v-if="childItem.hasPermission"
                  class="text-start w-100"
                  @click="$emit('fireToggleNavDrawerEmit')"
                >
                  <router-link :to="childItem.route">
                    <i class="fad fa-circle"></i>
                    {{ childItem.title }}
                  </router-link>
                </button>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </a-menu>
      </div> -->
      <!-- Start:: sideNavbarList_providers Route -->

      <!-- Start:: RequestWallets Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('requestwallets index', 'requestwallets')"
      >
        <router-link to="/RequestWallets/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/bill.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.Users.wallet-settlement-requests") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: RequestWallets Route -->

      <!-- Start:: workplaces Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('workplaces index', 'workplaces')"
      >
        <router-link to="/workplaces/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/house.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.workplaces") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: workplaces Route -->

      <!-- Start:: services Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('services index', 'services')"
      >
        <router-link to="/services/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/service.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.services") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: services Route -->

      <!-- Start:: places Route -->
      <v-list dense>
        <!-- نفس شرط الظهور -->
        <template
          v-if="
            $can('states index', 'states') ||
            $can('cities index', 'cities') ||
            $can('districts index', 'districts')
          "
        >
          <v-list-group
            v-for="item in sideNavbarList_Places"
            :key="item.key"
            no-action
            append-icon=""
          >
            <!-- الزر اللي بيفتح الدروب داون -->
            <template v-slot:activator>
              <div
                class="dropdown-activator d-flex align-center justify-space-between"
              >
                <div
                  class="route_icon d-flex justify-center"
                  style="
                    background-color: rgba(94, 231, 189, 0.3);
                    border-radius: 6px;
                    width: 40px;
                    height: 40px;
                  "
                >
                  <img
                    :src="item.icon"
                    alt="icon"
                    width="30"
                    height="30"
                    class="m-auto"
                  />
                </div>
                <span>{{ item.title }}</span>
                <i class="fas fa-angle-down"></i>
              </div>
            </template>

            <!-- العناصر الفرعية -->
            <v-list-item
              v-for="childItem in item.children"
              :key="childItem.key"
              v-if="childItem.hasPermission"
              @click="$emit('fireToggleNavDrawerEmit')"
            >
              <router-link
                :to="childItem.route"
                class="home_route d-flex align-center w-100"
              >
                <v-icon small class="mr-2">mdi-circle</v-icon>
                <span>{{ childItem.title }}</span>
              </router-link>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <!-- Start:: places Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('districts index', 'districts')"
      >
        <router-link to="/districts/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/village.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.districts") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: districts Route -->

      <!-- Start:: cities Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('countries index', 'countries')"
      >
        <router-link to="/countries/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/city.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.countries") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: cities Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('hobbies index', 'hobbies')"
      >
        <router-link to="/hobbies/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/hobby.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.hobbies_management") }}
          </span>
        </router-link>
      </div>
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('nationalities index', 'nationalities')"
      >
        <router-link to="/nationalities/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/nationalities.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.nationalities_management") }}
          </span>
        </router-link>
      </div> -->

      <!-- Start:: Customer Opinions Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('customeropinions index', 'customeropinions')"
      >
        <router-link to="/customeropinions/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/authourization.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.customer_opinions_management") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: Customer Opinions Route -->

      <!-- Start:: banks Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('banks index', 'banks')"
      >
        <router-link to="/banks/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/bank.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.banks.title") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: banks Route -->

      <!-- Start:: packages Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('packages index', 'packages')"
      >
        <router-link to="/packages/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(127, 211, 125, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/package.svg"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.package_management") }}
          </span>
        </router-link>
      </div>

      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('rent contracts index', 'rent-contracts')"
      >
        <router-link to="/contracts/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(127, 211, 125, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/contract.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.contracts_management") }}
          </span>
        </router-link>
      </div>

      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('ad complaints index', 'ad-complaints')"
      >
        <router-link to="/reports/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/reports.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.reports_management") }}
          </span>
        </router-link>
      </div>
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('estate types index', 'estate-types')"
      >
        <router-link to="/estate_types/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/building.svg"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.estate_types") }}
          </span>
        </router-link>
      </div>
      <!-- End:: packages Route -->

      <!-- Start:: auctions Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('auctions index', 'auctions')"
      >
        <router-link to="/auctions/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/adventage.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.auctions.title") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: auctions Route -->

      <!-- Start:: durations Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('auctiondurations index', 'auctiondurations')"
      >
        <router-link to="/durations/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/hs_code.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.durations") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: durations Route -->

      <!-- Start:: managements Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('management index', 'management')"
      >
        <router-link to="/managements/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/pm.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.manage_departments_and_managers") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: managements Route -->

      <!-- Start:: sectors Route -->
      <!-- <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('sections index', 'sections')"
      >
        <router-link to="/Sectors/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/module.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.sectors.title") }}
          </span>
        </router-link>
      </div> -->
      <!-- End:: sectors Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('ads index', 'ads')"
      >
        <router-link to="/chats/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/conversation.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.chats_management") }}
          </span>
        </router-link>
      </div>
      <!-- Start:: ads Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('sliders index', 'sliders')"
      >
        <router-link to="/Ads/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(212, 200, 72, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/ads2.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.ads.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: ads Route -->

      <!-- Start:: marketing campaigns Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('campaign_reports index', 'campaign_reports')"
      >
        <router-link to="/marketing-campaigns/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(0, 130, 116, 0.15);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/coupon.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.marketingCampaigns.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: marketing campaigns Route -->

      <!-- Start:: ads Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('ads index', 'ads')"
      >
        <router-link to="/advertisements/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/advertising.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.advertisement_management") }}
          </span>
        </router-link>
      </div>

      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('ads index', 'ads')"
      >
        <router-link to="/financial-packages/all">
          <span
            class="route_icon d-flex justify-center"
            style="border-radius: 6px; width: 40px; height: 40px"
          >
            <img
              src="@/assets/media/icons/ui_icons/package.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.financial_packages") }}
          </span>
        </router-link>
      </div>
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('ads index', 'ads')"
      >
        <router-link to="/financial-contracts/all">
          <span
            class="route_icon d-flex justify-center"
            style="border-radius: 6px; width: 40px; height: 40px"
          >
            <img
              src="@/assets/media/icons/ui_icons/contract.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.financial_contracts") }}
          </span>
        </router-link>
      </div>
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('ads index', 'ads')"
      >
        <router-link to="/financial-ads/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(212, 200, 72, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/ads2.png"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.financial_ads") }}
          </span>
        </router-link>
      </div>

      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('fqas index', 'fqas')"
      >
        <router-link to="/questions/all">
          <span
            class="route_icon d-flex justify-center"
            style="
              background-color: rgba(206, 70, 194, 0.3);
              border-radius: 6px;
              width: 40px;
              height: 40px;
            "
          >
            <img
              src="@/assets/media/icons/ui_icons/question.svg"
              alt="icon"
              width="30"
              height="30"
              class="m-auto"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.faq") }}
          </span>
        </router-link>
      </div>
      <!-- End:: FAQ Route -->

      <!-- Start:: app settings Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('settings index', 'settings')"
      >
        <router-link to="/app_settings">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/settings.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.settings.general_app") }}
          </span>
        </router-link>
      </div>
      <!-- End:: app settings Route -->
      <!-- Start:: notifications Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('notifications index', 'notifications')"
      >
        <router-link to="/all-notifications/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/notification.png"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("PLACEHOLDERS.notifications_management") }}
          </span>
        </router-link>
      </div>
      <!-- End:: notifications Route -->

      <v-list dense>
        <template v-if="$can('settings index', 'settings')">
          <v-list-group
            v-for="item in sideNavbarList"
            :key="item.key"
            style="border: none"
            no-action
            append-icon=""
          >
            <template v-slot:activator>
              <div
                class="dropdown-activator d-flex align-center justify-space-between"
              >
                <div
                  class="route_icon d-flex justify-center justify-space-between"
                  style="
                    background-color: rgba(94, 231, 189, 0.3);
                    border-radius: 6px;
                    width: 40px;
                    height: 40px;
                  "
                >
                  <img
                    :src="item.icon"
                    alt="icon"
                    width="30"
                    height="30"
                    class="m-auto"
                  />
                </div>
                <span>{{ item.title }}</span>
                <i class="fas fa-angle-down"></i>
              </div>
            </template>

            <!-- العناصر الفرعية -->
            <v-list-item
              v-for="childItem in item.children"
              :key="childItem.key"
              v-if="childItem.hasPermission"
              @click="$emit('fireToggleNavDrawerEmit')"
            >
              <router-link
                :to="childItem.route"
                class="home_route d-flex align-center w-100"
              >
                <v-icon small class="mr-2">mdi-circle</v-icon>
                <span>{{ childItem.title }}</span>
              </router-link>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <!-- Start:: Side Nav Routes -->

      <!-- End:: Side Nav Routes -->

      <!-- Start:: contacts Route -->
      <div
        class="home_route"
        @click="$emit('fireToggleNavDrawerEmit')"
        v-if="$can('contactus index', 'contactus')"
      >
        <router-link to="/contact-messages/all">
          <span class="route_icon">
            <img
              src="@/assets/media/icons/ui_icons/messages.svg"
              alt="icon"
              width="40"
              height="40"
            />
          </span>
          <span class="route_text">
            {{ $t("SIDENAV.ContactMessages.title") }}
          </span>
        </router-link>
      </div>
      <!-- End:: contacts Route -->

      <div class="side_routes_wrapper">
        <a-menu style="width: 100%" mode="inline">
          <!-- Start:: Logout Tab -->
          <a-sub-menu
            key="logout"
            @titleClick="logoutConfirmationModalIsOpen = true"
          >
            <!-- ========= Start:: Main Tab -->
            <span slot="title" class="logout_btn">
              <img
                src="../../assets/media/icons/ui_icons/logout.svg"
                alt="icon"
                width="35"
                height="35"
              />
              <span>
                {{ $t("SIDENAV.Logout.title") }}
              </span>
            </span>
            <!-- ========= End:: Main Tab -->
          </a-sub-menu>
          <!-- End:: Logout Tab -->
        </a-menu>
      </div>
      <!-- End:: Side Nav Routes -->

      <!-- Start:: Logout Confirmation Modal -->
      <v-dialog v-model="logoutConfirmationModalIsOpen">
        <v-card>
          <v-card-title class="text-h5 justify-center">
            {{ $t("TITLES.logoutConfirmingMessage") }}
          </v-card-title>
          <v-card-actions>
            <v-btn class="modal_confirm_btn" @click="logout">{{
              $t("BUTTONS.logout")
            }}</v-btn>

            <v-btn
              class="modal_cancel_btn"
              @click="logoutConfirmationModalIsOpen = false"
              >{{ $t("BUTTONS.cancel") }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End:: Logout Confirmation Modal -->
    </div>
  </div>
  <!-- End:: Side Nav Links -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SideNav",

  emits: ["fireToggleNavDrawerEmit"],

  props: {
    navIsActive: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    // Start:: Vuex Get Authenticated User Data
    ...mapGetters({
      getAppTheme: "AppThemeModule/getAppTheme",
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Get Authenticated User Data

    // Start:: Extract Side Nav Keys
    extractSideNavItemsKeys() {
      let extractedKeys = [];
      this.sideNavbarList_Admins.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_Places.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      this.sideNavbarList_Rates.forEach((element) => {
        extractedKeys.push(element["key"]);
      });
      return extractedKeys;
    },

    // End:: Extract Side Nav Keys
  },

  data() {
    return {
      isOpened: true,

      // Start:: Controle Open Tabs Data
      openKeys: [],
      // End:: Controle Open Tabs Data

      // Start:: Side Navbar List
      sideNavbarList_Admins: [
        {
          key: "dashboard",
          title: this.$t("SIDENAV.control_admins"),
          icon: require("@/assets/media/icons/ui_icons/panel.png"),
          hasPermission:
            this.$can("roles index", "roles") ||
            this.$can("admins index", "admins"),
          children: [
            {
              key: "roles",
              title: this.$t("SIDENAV.Roles.title"),
              route: "/roles/all",
              hasPermission:
                this.$can("roles index", "roles") ||
                this.$can("permissions index", "permissions"),
            },
            {
              key: "admins",
              title: this.$t("SIDENAV.Admins.title"),
              route: "/admins/all",
              hasPermission: this.$can("admins index", "admins"),
            },
          ],
        },
      ],

      sideNavbarList_Places: [
        {
          key: "dashboard_places",
          title: this.$t("PLACEHOLDERS.places"),
          icon: require("@/assets/media/icons/ui_icons/location.svg"),
          hasPermission:
            this.$can("states index", "states") ||
            this.$can("cities index", "cities") ||
            this.$can("districts index", "districts"),
          children: [
            {
              key: "states",
              title: this.$t("PLACEHOLDERS.manage_states"),
              route: "/states/all",
              hasPermission: this.$can("states index", "states"),
            },
            {
              key: "cities",
              title: this.$t("PLACEHOLDERS.manage_cities"),
              route: "/cities/all",
              hasPermission: this.$can("cities index", "cities"),
            },
            {
              key: "districts",
              title: this.$t("PLACEHOLDERS.manage_districts"),
              route: "/districts/all",
              hasPermission: this.$can("districts index", "districts"),
            },
          ],
        },
      ],

      sideNavbarList_users: [
        {
          key: "users_control",
          title: this.$t("PLACEHOLDERS.manage_users"),
          icon: require("@/assets/media/icons/ui_icons/clients.svg"),
          hasPermission: this.$can("clients index", "clients"),
          children: [
            {
              key: "users",
              title: this.$t("PLACEHOLDERS.manage_all_users"),
              route: "/clients/all",
              hasPermission: this.$can("clients index", "clients"),
            },
            {
              key: "joinUsers",
              title: this.$t("PLACEHOLDERS.joinClients"),
              route: "/joinClients/all",
              hasPermission: this.$can("clients index", "clients"),
            },
          ],
        },
      ],

      sideNavbarList: [
        {
          key: "appContent",
          title: this.$t("SIDENAV.AppContent.title"),
          icon: require("@/assets/media/icons/ui_icons/book_mark.svg"),
          children: [
            // {
            //   key: "contact-messages",
            //   title: this.$t("SIDENAV.ContactMessages.title"),
            //   route: "/contact-messages/all",
            //   hasPermission: this.$can("contactus index", "contactus"),
            // },
            {
              key: "contact",
              title: this.$t("PLACEHOLDERS.contact_admins"),
              route: "/contact_settings",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "aboutPlatform",
              title: this.$t("SIDENAV.AppContent.aboutPlatform"),
              route: "/app-content/about-us",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "termsAndConditions",
              title: this.$t("SIDENAV.AppContent.termsAndConditions"),
              route: "/app-content/terms",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "privacyPolicy",
              title: this.$t("SIDENAV.AppContent.privacyPolicy"),
              route: "/app-content/policy",
              hasPermission: this.$can("settings create", "settings"),
            },
            {
              key: "delete-account",
              title: this.$t("PLACEHOLDERS.how_to_delete_account"),
              route: "/app-content/delete-account",
              hasPermission: this.$can("settings create", "settings"),
            },
          ],
        },
      ],

      sideNavbarList_Rates: [
        {
          key: "rates",
          title: this.$t("PLACEHOLDERS.comments_management"),
          icon: require("@/assets/media/icons/ui_icons/star.svg"),
          hasPermission: this.$can("rates index", "rates"),
          children: [
            {
              key: "app_rate",
              title: this.$t("PLACEHOLDERS.app_ratings"),
              route: "/app-rate/all",
              hasPermission: this.$can("rates apprates", "rates"),
            },
            {
              key: "store_rate",
              title: this.$t("PLACEHOLDERS.store_ratings"),
              route: "/store-rate/all",
              hasPermission: this.$can("rates salonrates", "rates"),
            },
          ],
        },
      ],

      sideNavbarList_providers: [
        {
          key: "providers",
          title: this.$t("PLACEHOLDERS.teachers_management"),
          icon: require("@/assets/media/icons/ui_icons/clients.svg"),
          hasPermission: this.$can("teachers index", "teachers"),
          children: [
            {
              key: "providers_join",
              title: this.$t("PLACEHOLDERS.teachers_join_requests"),
              route: "/teachers-requests/all",
              hasPermission: this.$can("teachers index", "teachers"),
            },
            {
              key: "providers_list",
              title: this.$t("PLACEHOLDERS.teachers"),
              route: "/teachers/all",
              hasPermission: this.$can("teachers index", "teachers"),
            },
          ],
        },
      ],

      // Start:: Modal Controlling Data
      logoutConfirmationModalIsOpen: false,
      // End:: Modal Controlling Data
    };
  },

  methods: {
    // Start:: Vuex Auth Actions
    ...mapActions({
      logout: "AuthenticationModule/logout",
    }),
    // End:: Vuex Auth Actions
    handleClick() {
      this.open = !this.open;
    },
    closeMenu() {
      this.open = false;
    },
    onOpen() {
      this.isOpened = !this.isOpened;
    },

    handleClickOrder() {
      this.openOrder = !this.openOrder;
    },
    closeMenuOrder() {
      this.openOrder = false;
    },
    handleClickcities() {
      this.openCities = !this.openCities;
    },
    closeMenuCities() {
      this.openCities = false;
    },
    // Start:: Controle Open Tabs
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.extractSideNavItemsKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    // End:: Controle Open Tabs
  },

  created() {},
};
</script>

<style>
.close-side {
  background-color: #008274;
  border: none;
  position: relative;
  z-index: 10;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin: 10px !important;
  display: none !important;
  margin-inline-start: auto !important;
  margin-inline-end: 20px !important;

  display: block;
}

.close-side i {
  font-size: 1.2rem;

  color: white;
  transition: color 0.2s ease;
}

.close-side:hover {
  background-color: #e0e0e0;
  transform: scale(1.05);
}

.close-side:active {
  transform: scale(0.95);
  background-color: #d6d6d6;
}
.side_nav_wrapper.closed .close-side {
  margin: 10px !important;
}
.side_nav_wrapper.closed {
  transition: all 0.3s;
  padding: 0px !important;
}
.side_nav_wrapper .side_nav_links_wrapper {
  transition: all 0.3s;
}

@media (min-width: 1100px) {
  .side_nav_wrapper.closed .side_nav_links_wrapper {
    width: 0px;
    padding: 0px !important;
    display: none !important;
  }
  .side_nav_wrapper.closed {
    width: 0px !important;
  }
  .side_nav_wrapper {
    transition: all 0.3s;
    width: 20vw !important;
  }
  .close-side {
    display: block !important;
  }
}
.side_nav_wrapper {
  flex-shrink: 0;
}

.logo {
  background-color: transparent !important;
}
.v-list-item--link {
  padding: 0px !important;
}
.v-list-item--link span {
  white-space: normal;
  word-break: break-word;
}
.v-list-item--link a {
  width: 100%;
  white-space: normal;
  word-break: break-word;
}
.v-list-item--link,
.v-list-item--link a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  -moz-column-gap: 12px;
  column-gap: 12px;

  border-radius: 7px;
  transition: 0.5s;
  padding: 5px;
  font-size: 18px;
  color: var(--theme_text_clr) !important;
}
.v-list-item {
  padding: 10px;
}
.v-list-item--link a:hover {
  color: white !important;
}
.v-list-item--link:hover {
  background-color: #008274 !important;
  color: white !important;
}
.v-list-item--link {
  display: flex;
}
.v-list-item--link a {
  color: inherit;
  border: none !important;
  font-size: 14px;
}

.v-list-item--link span {
  flex-shrink: 0;
}
.v-list-group__items {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 4px 4px;
}
.v-list-group__items .v-list-item--link span {
  flex-shrink: 1;
}
.dropdown-activator {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  padding: 9px;
}
.dropdown-activator i {
  margin-inline-start: auto;
  transform: 0.3s;
}
.dropdown-activator > div {
  gap: 2px;
}
.v-list-group--active .dropdown-activator i {
  transform: scale(-1);
}

.v-list {
  background: transparent !important;
}

@media (max-width: 1100px) {
  .v-list-item--link a {
    color: white !important;
  }
}
@media (min-width: 1100px) {
  .app_structure_wrapper {
    align-items: flex-start !important;
  }
  .app_structure_wrapper .dashboard_body_wrapper .inner_structure_wrapper {
    min-height: auto !important ;
    max-height: auto !important;
  }
}

.logo_wrapper {
  padding-bottom: 10px;
  padding-top: 0px !important;
}

@media (min-width: 1100px) and (max-width: 1330px) {
  .route_text,
  .dropdown-activator span {
    font-size: 14px !important;
  }
  .route_icon {
    width: 35px !important;
    height: 35px !important;
  }
  .route_icon img {
    width: 25px !important;
    height: 25px !important;
  }
  .side_nav_links_wrapper {
    padding-inline: 8px !important;
  }
}
</style>
